import {
  Flex,
  PartnerLogo,
  Typography as ReeferTypography,
} from '@iheartjane/reefer';
import type { ComponentType, ReactNode, RefObject } from 'react';

import styles from './adLayout.module.css';

interface AdLayoutProps {
  brandBlockRef?: RefObject<HTMLDivElement | null>;
  brandLogoUrl: string;
  brandName: string;
  children: ReactNode;
  productsRowRef?: RefObject<HTMLDivElement | null>;
  taglineText: string;
  typography?: ComponentType;
  typographyColor: 'grays-black' | 'grays-white';
}

export const AdLayout = ({
  brandBlockRef,
  brandLogoUrl,
  brandName,
  children,
  productsRowRef,
  taglineText,
  typography,
  typographyColor,
}: AdLayoutProps) => {
  const Typography = typography || ReeferTypography;

  return (
    <Flex
      height="100%"
      p={24}
      position="relative"
      width="100%"
      zIndex={3}
      className={styles['layout']}
      data-testid="custom-image-ad-layout"
      justifyContent="space-between"
      gap={12}
    >
      <Flex
        ref={brandBlockRef}
        className={styles['brandBlock']}
        data-testid="custom-image-ad-brand"
        minWidth={0}
        gap={24}
        alignItems="center"
        alignSelf="end"
      >
        <PartnerLogo
          variant="brand"
          size="md"
          name={brandName}
          image={brandLogoUrl}
          className={styles['brandLogo']}
          style={{ background: 'white' }}
        />

        <Flex
          flexDirection="column"
          minWidth={0}
          gap={4}
          className={styles['brandText']}
        >
          <Typography
            className={styles['brandName']}
            overflow="hidden"
            whiteSpace="nowrap"
            maxLines={1}
            variant="h2-semibold"
            color={typographyColor}
            branded
          >
            {brandName}
          </Typography>
          <Typography
            className={styles['tagline']}
            overflow="hidden"
            whiteSpace="nowrap"
            maxLines={1}
            color={typographyColor}
          >
            {taglineText}
          </Typography>
        </Flex>
      </Flex>

      <Flex
        ref={productsRowRef}
        alignItems="flex-end"
        data-testid="custom-image-ad-products"
        height="100%"
        gap={16}
        className={styles['productsRow']}
      >
        {children}
      </Flex>
    </Flex>
  );
};
